export default "__VITE_ASSET__DBuZinAK__"